export default __webpack_public_path__ + "images/2c0fe916ddf55200a8ad38cdfc4e222c.png";